import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acPopVizibil } from '../actions/acPopVizibil';
import { acNullify } from '../actions/acNullify';

import PopIstoricRunde from '../containers/PopIstoricRunde';
import PopIstoricPariuri from '../containers/PopIstoricPariuri';
import PopOficialLinks from '../containers/PopOficialLinks'
import PopWidgetClasament from '../containers/PopWidgetClasament';
import PopWidgetClasamentLastResults from '../containers/PopWidgetClasamentLastResults';

class PopUp extends React.Component {

    componentWillMount() {
        document.addEventListener('click', this.handleClick.bind(this), false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick.bind(this), false);
    }
    componentDidUpdate(prevProps, prevState) {
        // this.props.acConSizeChange({ popUp: 0 })
    }

    handleClick(e) {
        if (e.target.className === "con-popUp") {
            this.props.acPopVizibil({ popVizibil: false });
            this.props.acNullify('POP-UP-TABEL');
        }
    }

    visibleBg() {
        if ((this.props.popVizibil !== null) && (this.props.popVizibil.popVizibil === true)) {
            return 'active';
        } else {
            return '';
        }
    }
    popUpType() {
        if (this.props.popVizibil.info !== null) {
            if (this.props.popVizibil.info.type === 'runde') {
                return <PopIstoricRunde />
            }
            if (this.props.popVizibil.info.type === 'pariuri') {
                return <PopIstoricPariuri />
            }
            if (this.props.popVizibil.info.type === "oficialLinks") {
                return <PopOficialLinks />;
            }
            if (this.props.popVizibil.info.type === "clasamentWidget") {
                return <PopWidgetClasament />;
            }
            if (this.props.popVizibil.info.type === 'clasamentWidgetLastResults') {
                return <PopWidgetClasamentLastResults />
            }
        }
    }

    render() {
        if ((this.props.popVizibil !== null) && (this.props.popVizibil.vizibil === true)) {
            return (
                <div className="con-popUp">
                    <div className={"popUp " + this.props.popVizibil.info.type} style={{ marginTop: this.props.popVizibil.position.y, marginLeft: this.props.popVizibil.position.x }}>
                        {this.popUpType()}
                    </div>
                </div>
            )
        }
        else {
            return <div></div>
        }
    }
}

function mapStateToProps(state) {
    return {
        popVizibil: state.popVizibil,
        alert: state.alert
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acPopVizibil: acPopVizibil,
        acNullify: acNullify,
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(PopUp);